/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ConfigService} from './config.service';

@Injectable({
  providedIn: 'root'
})

export class BrandfamService {
  constructor(private readonly configService: ConfigService,
              private readonly http: HttpClient) {
  }

  /**
   * gets all brandfams associated with a given propulsion scenario
   * @param propScenId id of a given propulsion scenario
   */
  getBrandfamsByPropulsionScenario(propScenId: number): Observable<string[]> {
    const params = new HttpParams()
    .set('prop-scen-id', propScenId);
    return this.http.get<string[]>(`${this.configService.baseApiUrl}brandfam`, {params})
    .pipe(catchError(myError => this.handleError(myError)));

  }

  /**
   * Handles the errors produced by the backend
   * @param errorResponse The error produced by the API to be handled by the frontend
   */
  private handleError(errorResponse: HttpErrorResponse): Observable<any> {
    let errorMessage = 'An unexpected error has occurred.';
    if (errorResponse.error && errorResponse.error.message) {
      errorMessage = errorResponse.error.message;
    }
    return throwError(errorMessage);
  }
}
